import React from 'react';
import Preview from '../previews/Address';

const AddressQuestion = ({ activeStep, question }) => {
  return <></>;
};

AddressQuestion.StepsCount = 2;
AddressQuestion.StepDescription =
  'Select which fields you would like to include in this question';
AddressQuestion.Preview = Preview;

export default AddressQuestion;
